import {ChangeDetectorRef, Component, forwardRef, Injector, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormBuilder } from '@angular/forms';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { KANBAN_TYPE_TASK, KanbanModel } from '../kanban.model';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { MdKanbanFormAddTaskDialogComponent } from './@modals/md-kanban-form-add-task-dialog/md-kanban-form-add-task-dialog.component';
import {v4 as uuidv4} from 'uuid';
import { MdKanbanFormFactureDepotDialogComponent } from './@modals/md-kanban-form-facture-depot-dialog/md-kanban-form-facture-depot-dialog.component';
import { MdKanbanFormChequeRetraitDialogComponent } from './@modals/md-kanban-form-cheque-retrait-dialog/md-kanban-form-cheque-retrait-dialog.component';
import { MdKanbanFormChequeDepotDialogComponent } from './@modals/md-kanban-form-cheque-depot-dialog/md-kanban-form-cheque-depot-dialog.component';
import { AbwConfirmDialogService } from 'src/app/shared/abw-confirm-dialog/abw-confirm-dialog.service';

@Component({
    selector: 'abw-kanban-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => KanbanFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => KanbanFormComponent),
        multi: true
      }
    ],
    templateUrl: './kanban-form.component.html',
    styleUrls: ['./kanban-form.component.scss']
})
export class KanbanFormComponent extends AbstractWorkflowFormComponent<KanbanModel, any> implements OnInit, OnChanges {
  datas = [];
  clients = [];
  banques = [];
  cheques = [];
  factures = [];
  facturesClients = [];
  facturesZones = [];
  initializationError = false;
  filteredDatas = [...this.datas];
  filteredForm = this._formBuilder.group({
      ELEMENT_FILTER: [''],
      DATE_FILTER: [moment().format('YYYY-MM-DD')]
  });
  KANBAN_TYPE_TASK = KANBAN_TYPE_TASK;
  tasksValue: any = {};

  constructor(
    private _formBuilder: FormBuilder,
    private _dialog: MatDialog,
    private _confirmDialog: AbwConfirmDialogService,
    _workflowComponentsService: WorkflowComponentsService,
    _cdf: ChangeDetectorRef,
    _injector: Injector,
  ) {
    super(_workflowComponentsService, _cdf, _injector);
  }

  ngOnInit() {
    this.filteredForm.valueChanges.subscribe(filteredValues => {
        this._doApplyFilters();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.model?.currentValue) {
      try {
        this.initializationError = false;

        const valuePropName = this.model.additional.UIC_PARAMS.DATASOURCE.DATASOURCE_VALUE_FIELD;
        const displayPropName = this.model.additional.UIC_PARAMS.DATASOURCE.DATASOURCE_DISPLAY_FIELD;
        this.datas = this.model.additional.UIC_PARAMS.DATASOURCE.DATASOURCE_FILTERED_DATAS.map(d => {
          const id = d[valuePropName];
          return {
            ID: id,
            NAME: d[displayPropName],
            ITEMS: this.model.additional.UIC_PARAMS.NUM_DATASOURCE_VALUES?.DATASOURCE_FILTERED_DATAS[id] || []
          };
        });

        const valuePropNameClient = this.model.additional.UIC_PARAMS.DATASOURCE_CLIENTS.DATASOURCE_VALUE_FIELD;
        const displayPropNameClient = this.model.additional.UIC_PARAMS.DATASOURCE_CLIENTS.DATASOURCE_DISPLAY_FIELD;
        this.clients = this.model.additional.UIC_PARAMS.DATASOURCE_CLIENTS.DATASOURCE_FILTERED_DATAS.map(d => ({
          ID: d[valuePropNameClient],
          TEXT: d[displayPropNameClient]
        }));

        const valuePropNameBanque = this.model.additional.UIC_PARAMS.DATASOURCE_BANQUES.DATASOURCE_VALUE_FIELD;
        const displayPropNameBanque = this.model.additional.UIC_PARAMS.DATASOURCE_BANQUES.DATASOURCE_DISPLAY_FIELD;
        this.banques = this.model.additional.UIC_PARAMS.DATASOURCE_BANQUES.DATASOURCE_FILTERED_DATAS.map(d => ({
          ID: d[valuePropNameBanque],
          TEXT: d[displayPropNameBanque]
        }));

        const rowIdPropNameCheque = this.model.additional.ROWID_COLUMN_NAME_CHEQUES;
        const valuePropNameCheque = this.model.additional.UIC_PARAMS.DATASOURCE_CHEQUES.DATASOURCE_VALUE_FIELD;
        const displayPropNameCheque = this.model.additional.UIC_PARAMS.DATASOURCE_CHEQUES.DATASOURCE_DISPLAY_FIELD;
        this.cheques = this.model.additional.UIC_PARAMS.DATASOURCE_CHEQUES.DATASOURCE_FILTERED_DATAS.map(d => ({
          ID: d[valuePropNameCheque],
          TEXT: d[displayPropNameCheque],
          ROWID: d[rowIdPropNameCheque]
        }));

        const valuePropNameFactures = this.model.additional.VALUE_COLUMN_NAME_FACTURES;
        const displayPropNameFactures = this.model.additional.DISPLAY_COLUMN_NAME_FACTURES;
        const totalTTCPropNameFactures = this.model.additional.TOTALTTC_COLUMN_NAME_FACTURES;
        const numTiersPropNameFactures = this.model.additional.DO_TIERS_COLUMN_NAME_FACTURES;
        const libTiersPropNameFactures = this.model.additional.LIB_TIERS_COLUMN_NAME_FACTURES;
        const zonePropNameFactures = this.model.additional.ZONES_COLUMN_NAME_FACTURES;
        
        this.factures = this.model.additional.UIC_PARAMS.DATASOURCE_FACTURES.DATASOURCE_FILTERED_DATAS.map(d => ({
          ID: d[valuePropNameFactures],
          TEXT: d[displayPropNameFactures],
          TOTALTTC: d[totalTTCPropNameFactures],
          NUM_TIERS: d[numTiersPropNameFactures],
          LIB_TIERS: d[libTiersPropNameFactures],
          ZONE: d[zonePropNameFactures],
          raw: d
        }));
        this.facturesClients = [...new Map(
            this.factures.map(item => [
                item.NUM_TIERS,
                {
                    NUM_TIERS: item.NUM_TIERS,
                    LIB_TIERS: item.LIB_TIERS,
                    ZONE: item.ZONE
                }
            ])
        ).values()];
        this.facturesZones = [...new Map(
            this.factures.map(item => [
                item.ZONE,
                {
                  ZONE: item.ZONE || 'Inconnu'
                }
            ])
        ).values()];

        this._doApplyFilters();
        setTimeout(() => this._doEvaluateValue(), 10);
      } catch(err) {
        console.error(err);
        this.initializationError = true;
      }
    }
  }

  private _doApplyFilters() {
      const filteredValues = this.filteredForm.value;
      let filteredDatas = JSON.parse(JSON.stringify(this.datas));
      if (!!filteredValues.ELEMENT_FILTER) {
          filteredDatas = filteredDatas.filter(d => d.ID == filteredValues.ELEMENT_FILTER);
      }

      if (!!filteredValues.DATE_FILTER) {
          for(var d in filteredDatas) {
              filteredDatas[d].ITEMS = filteredDatas[d].ITEMS.filter(item => moment(item.DATE_CREATION).isSame(moment(filteredValues.DATE_FILTER), 'day'));
          }
      }

      this.filteredDatas = filteredDatas;
  }

  doOpenAddTaskDialog(kanbanItem: any) {
      const dialogRef = this._dialog.open(MdKanbanFormAddTaskDialogComponent, {
          data: {
              kanbanItem: kanbanItem,
              startupInfos: {
                  CLIENTS: this.clients,
                  BANQUES: this.banques,
                  CHEQUES: this.cheques,
                  FACTURES: this.factures,
                  CLIENTS_FACTURES: this.facturesClients,
                  ZONES_FACTURES: this.facturesZones
              }
          },
          width: '100vw',
          panelClass: 'datasource-designer-modal'
      });
      dialogRef.componentInstance.onTasksAdded$.subscribe((tasks: any[]) => {
        tasks.forEach(task => {
          const index = this.datas.findIndex(d => d.ID == kanbanItem.ID);
          if (index > -1) {
              const taskIndex = !!task.ID ? this.datas[index].ITEMS.findIndex(i => i.ID == task.ID) : -1;
              if (taskIndex > -1) {
                  this.datas[index].ITEMS[taskIndex] = task;
              } else {
                  task.ID = uuidv4();
                  task.DATE_CREATION = new Date();
                  task.RESPONSE_WORKFLOW_LOCAL_ID = this.model.responseWorkflowLocalId;
                  task.ID_ELEMENT = kanbanItem.ID;
                  task.LABEL_ELEMENT = kanbanItem.NAME;
                  this.datas[index].ITEMS.unshift(task);
              }
          }
        });
        this._doApplyFilters();
        this._doEvaluateValue();
        this._cdf.detectChanges();
      });
  }

  async doEditTaskAction(kanbanItem: any, taskItem: any) {
    let dialogResult: any = null;
    
    if (taskItem.TYPE_TASK == KANBAN_TYPE_TASK.DEPOT_CHEQUE) {
      dialogResult = await this._dialog.open(MdKanbanFormChequeDepotDialogComponent, {
          data: {
              kanbanItem: kanbanItem,
              item: taskItem,
              startupInfos: {
                  CLIENTS: this.clients,
                  BANQUES: this.banques,
                  CHEQUES: this.cheques,
                  FACTURES: this.factures,
                  CLIENTS_FACTURES: this.facturesClients,
                  ZONES_FACTURES: this.facturesZones
              }
          },
          width: '100vw',
          panelClass: 'datasource-designer-modal'
      }).afterClosed().toPromise();
    } else if (taskItem.TYPE_TASK == KANBAN_TYPE_TASK.RETRAIT_CHEQUE) {
      dialogResult = await this._dialog.open(MdKanbanFormChequeRetraitDialogComponent, {
          data: {
              kanbanItem: kanbanItem,
              item: taskItem,
              startupInfos: {
                  CLIENTS: this.clients,
                  BANQUES: this.banques,
                  CHEQUES: this.cheques,
                  FACTURES: this.factures,
                  CLIENTS_FACTURES: this.facturesClients,
                  ZONES_FACTURES: this.facturesZones
              }
          },
          width: '100vw',
          panelClass: 'datasource-designer-modal'
      }).afterClosed().toPromise();
    } else if (taskItem.TYPE_TASK == KANBAN_TYPE_TASK.DEPOT_FACTURE) {
      dialogResult = await this._dialog.open(MdKanbanFormFactureDepotDialogComponent, {
          data: {
              kanbanItem: kanbanItem,
              item: taskItem,
              startupInfos: {
                  CLIENTS: this.clients,
                  BANQUES: this.banques,
                  CHEQUES: this.cheques,
                  FACTURES: this.factures,
                  CLIENTS_FACTURES: this.facturesClients,
                  ZONES_FACTURES: this.facturesZones
              }
          },
          width: '100vw',
          panelClass: 'datasource-designer-modal'
      }).afterClosed().toPromise();
    }

    if (!!dialogResult?.data) {
      const index = this.datas.findIndex(d => d.ID == kanbanItem.ID);
      if (index > -1) {
          const taskIndex = this.datas[index].ITEMS.findIndex(i => i.ID == taskItem.ID);
          if (taskIndex > -1) {
            const paramsTaskList = Array.isArray(dialogResult.data) ? dialogResult.data : [dialogResult.data];
            this.datas[index].ITEMS[taskIndex].PARAMS_TASK = paramsTaskList[0];
            for (let i = 1; i < paramsTaskList.length; i++) {
                this.datas[index].ITEMS.unshift({
                    ID: uuidv4(),
                    TYPE_TASK: taskItem.TYPE_TASK,
                    PARAMS_TASK: paramsTaskList[i],
                    DATE_CREATION: new Date(),
                    RESPONSE_WORKFLOW_LOCAL_ID: this.model.responseWorkflowLocalId,
                    ID_ELEMENT: kanbanItem.ID,
                    LABEL_ELEMENT: kanbanItem.NAME
                });
            }
            this._doApplyFilters();
            this._doEvaluateValue();
            this._cdf.detectChanges();
          }
      }
    }
  }

  async doDeleteTaskAction(kanbanItem: any, taskItem: any) {
    const confirmation = await this._confirmDialog.showConfirmDialog('Suppression Tâche', 'Voulez-vous vraiment supprimer cette tâche ?')
    if (confirmation) {
      const index = this.datas.findIndex(d => d.ID == kanbanItem.ID);
      if (index > -1) {
          const taskIndex = this.datas[index].ITEMS.findIndex(i => i.ID == taskItem.ID);
          if (taskIndex > -1) {
            this.datas[index].ITEMS.splice(taskIndex, 1);
            this._doApplyFilters();
            this._doEvaluateValue();
            this._cdf.detectChanges();
          }
      }
    }
  }

  drop(event: CdkDragDrop<string[]>) {
      const containerKanbanId = event.container.element.nativeElement.getAttribute('kanban-id');
      const containerIndex = this.datas.findIndex(d => d.ID == containerKanbanId);
      if (event.previousContainer === event.container) {
          moveItemInArray(this.datas[containerIndex].ITEMS, event.previousIndex, event.currentIndex);
      } else {
          const previousContainerKanbanId = event.previousContainer.element.nativeElement.getAttribute('kanban-id');
          const previousContainerIndex = this.datas.findIndex(d => d.ID == previousContainerKanbanId);
          transferArrayItem(this.datas[previousContainerIndex].ITEMS, this.datas[containerIndex].ITEMS, event.previousIndex, event.currentIndex);
      }

      for (var d in this.datas) {
        for (var i in this.datas[d].ITEMS) {
          this.datas[d].ITEMS[i].ID_ELEMENT = this.datas[d].ID;
          this.datas[d].ITEMS[i].LABEL_ELEMENT = this.datas[d].NAME;
        }
      }
      this._doApplyFilters();
      this._doEvaluateValue();
      this._cdf.detectChanges();
  }

  private _doEvaluateValue() {
    this.datas.forEach(d => {
      this.tasksValue[d.ID] = d.ITEMS;
    });
    this.propagateChange(this.tasksValue);
  }
}